<script lang="ts">
	import { t } from '#lib/stores/i18n.js';
	import WidgetButton from '#lib/widget/components/WidgetButton.svelte';
	import { resetWidget } from '#lib/widget/booking/flow.js';
</script>

<div class="mt-16 mx-auto flex items-center justify-center">
	<WidgetButton
		height="h-6"
		iconSizeClasses="w-4 h-4"
		width="w-fit"
		icon="company"
		transparentBackground
		textClasses="text-sm opacity-60"
		onclick={resetWidget}
	>
		{$t('widget-external.home')}
	</WidgetButton>
</div>
